import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactHero = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary via-secondary to-primary overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-accent rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-purple-500 rounded-full blur-3xl animate-pulse delay-1000"></div>
      </div>

      <div className="container mx-auto px-4 py-20 lg:py-28 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 bg-accent/10 backdrop-blur-sm border border-accent/20 rounded-full px-6 py-2 mb-6">
            <Icon name="Headphones" size={20} color="var(--color-accent)" />
            <span className="text-accent font-medium text-sm">Поддержка 24/7</span>
          </div>

          <h1 className="text-4xl lg:text-6xl font-headline font-bold text-white mb-6 leading-tight">
            Мы здесь, чтобы помочь вам
          </h1>

          <p className="text-xl text-gray-200 mb-8 max-w-2xl mx-auto leading-relaxed">
            Получите экспертную поддержку, техническую документацию и ресурсы для успешного внедрения Jetu AI в ваш бизнес
          </p>

          <div className="flex flex-wrap justify-center gap-4">
            <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-lg px-6 py-3">
              <Icon name="Clock" size={20} color="#FFFFFF" />
              <span className="text-white font-medium">Ответ в течение 2 часов</span>
            </div>
            <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-lg px-6 py-3">
              <Icon name="Users" size={20} color="#FFFFFF" />
              <span className="text-white font-medium">5000+ довольных клиентов</span>
            </div>
            <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-lg px-6 py-3">
              <Icon name="Award" size={20} color="#FFFFFF" />
              <span className="text-white font-medium">98% удовлетворенность</span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background to-transparent"></div>
    </section>
  );
};

export default ContactHero;